import * as React from 'react';
import { styled } from '@mui/system';
import { Tabs, Tab, useMediaQuery } from '@mui/material';
import { tabClasses } from '@mui/material/Tab';
import { buttonClasses } from '@mui/material/Button';
import { useEffect } from 'react';

export default function DynamicToggleTabs({ onSelectTab, value1, value2, revnueValue }) {
  const colorObj = {
    50: '#fff',
    100: '#C2E0FF',
    200: '#80BFFF',
    300: '#66B2FF',
    400: '#F0F7FF',
    500: "#F2F2F2",
    600: '#F14950',
    700: '#0059B2',
    800: '#004C99',
    900: '#003A75',
  };

  // --------- DESIGN: inner pill tabs ----------
  const StyledTab = styled(Tab)`
    font-family: 'IBM Plex Sans', sans-serif;
    color: rgba(76, 78, 100, 0.87);
    text-transform: none;
    cursor: pointer;
    font-size: 0.8rem;
    font-weight: 600;
    background-color: transparent;
    line-height: 1.5;
    padding: 4px 14px;
    margin: 2px;
    border: none;
    border-radius: 9999px;   /* full pill */
    display: flex;
    justify-content: center;
    min-height: 24px;
    min-width: auto;

    /* hover: light white pill, red text */
    &:hover {
      background-color: #FFFFFF;
      color: #F14950;
    }

    &:focus {
      color: ${colorObj[600]};
      outline: 0;
    }

    /* selected: white pill with red text (like screenshot) */
    &.${tabClasses.selected} {
      background-color: #FFFFFF;
      color: #F14950;
      height: 32px;
    }

    &.${buttonClasses.disabled} {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `;

  // --------- DESIGN: outer track ----------
  const StyledTabs = styled(Tabs)`
    min-width: ${props => (props.smScreen ? '120px' : '165px')};
    min-height: 39px;
    background-color: ${colorObj[500]};
    border-radius: 9999px;
    padding: 2px;
    margin-bottom: 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: ${props =>
      props.theme.palette.mode === 'dark'
        ? '0 2px 4px rgba(0,0,0,0.4)'
        : '0 2px 4px rgba(0,0,0,0.2)'};

    & .MuiTabs-flexContainer {
      display: inline-flex;
    }
  `;

  const [selectedTab, setSelectedTab] = React.useState(2);
  const smScreen = useMediaQuery('(max-width:600px)');

  useEffect(() => {
    if (revnueValue && (value1 === 'Overall Royalty' || value1 === 'Studio Royalty')) {
      setSelectedTab(revnueValue);
      onSelectTab(revnueValue);
    }
  }, [revnueValue, onSelectTab, value1]);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    onSelectTab(newValue);
  };

  return (
    <StyledTabs
      value={selectedTab}
      onChange={handleTabChange}
      variant="scrollable"
      scrollButtons="auto"
      aria-label="scrollable auto tabs example"
      smScreen={smScreen}
      TabIndicatorProps={{
        style: {
          display: 'none',
        },
      }}
    >
      {/* value=2 will be initially selected: e.g., "Youth" */}
      <StyledTab label={value1} value={2} />
      <StyledTab label={value2} value={1} />
    </StyledTabs>
  );
}
